import { Component } from 'react'
import { SlideProps } from "./types";

export default class Slide extends Component<SlideProps> {
  render () {
    return this.props.children
  }
}
